import React from "react";
import { BiSolidUser } from "react-icons/bi";
import { Link } from "react-router-dom";

const ProfileButton = ({ className, path }) => {
  return (
    <Link
      to={`${path || ""}settings/personal-data`}
      className={`h-[44px] w-[44px] bg-white flex items-center justify-center rounded-xl ${className}`}
    >
      <BiSolidUser className="text-2xl" />
    </Link>
  );
};

export default ProfileButton;
